import cornerstoneTools from 'cornerstone-tools';
import pointInsideBoundingBox from './pointInsideBoundingBox.js';

const BaseAnnotationTool = cornerstoneTools.importInternal('base/BaseAnnotationTool');
const getNewContext = cornerstoneTools.importInternal('drawing/getNewContext');
const draw = cornerstoneTools.importInternal('drawing/draw');
const setShadow = cornerstoneTools.importInternal('drawing/setShadow');
const drawTextBox = cornerstoneTools.importInternal('drawing/drawTextBox');

const cursors = cornerstoneTools.importInternal('tools/cursors');

export default class SimpleTextTool extends BaseAnnotationTool {
    constructor(name = 'SimpleTextTool') {
        super({
            name,
            supportedInteractionTypes: ['Mouse', 'Touch'],
            // configuration: {
            //     markers: [],
            //     current: '',
            //     ascending: true,
            //     loop: false,
            //     changeTextCallback,
            // },
            svgCursor: cursors.angleCursor,
        });

        // console.log("angleCursor", cursors.angleCursor);
    }

    createNewMeasurement(eventData) {
        // const config = this.configuration;

        // if (!config.current) {
        //   return;
        // }

        // console.log("eventData.currentPoints", eventData.currentPoints);

        // Create the measurement data for this tool with the end handle activated
        const measurementData = {
            visible: true,
            active: true,
            text: "TODO: text will go here !!!",
            color: undefined,
            handles: {
                end: {
                    x: eventData.currentPoints.image.x,
                    y: eventData.currentPoints.image.y,
                    highlight: true,
                    active: true,
                    // active: false,
                    hasBoundingBox: true,
                },
            },
        };

        // Create a rectangle representing the image
        const imageRect = {
            left: 0,
            top: 0,
            width: eventData.image.width,
            height: eventData.image.height,
        };

        // Check if the current handle is outside the image,
        // If it is, prevent the handle creation

        // if (
        //     !cornerstoneTools.external.cornerstoneMath.point.insideRect(
        //         measurementData.handles.end,
        //         imageRect
        //     )
        // ) {
        //     return;
        // }
        
        // // Update the current marker for the next marker
        // let currentIndex = config.markers.indexOf(config.current);

        // const increment = config.ascending ? 1 : -1;

        // currentIndex += increment;

        // if (currentIndex >= config.markers.length) {
        //   currentIndex = config.loop ? 0 : -1;
        // } else if (currentIndex < 0) {
        //   currentIndex = config.loop ? config.markers.length : -1;
        // }

        // config.current = config.markers[currentIndex];

        // console.log("measurementData", measurementData)

        return measurementData;
    }

    pointNearTool(element, data, coords) {
        if (data.visible === false) {
            return false;
        }

        if (!data.handles.end.boundingBox) {
            return;
        }

        const distanceToPoint = cornerstoneTools.external.cornerstoneMath.rect.distanceToPoint(
            data.handles.end.boundingBox,
            coords
        );
        const insideBoundingBox = pointInsideBoundingBox(data.handles.end, coords);

        return distanceToPoint < 10 || insideBoundingBox;
    }

    updateCachedStats() {
        // Implementing to satisfy BaseAnnotationTool
    }

    // TODO: this needs to be disabled if read from file and not created within the sesssion !!!
    // FIXME: even when we do have any other tool selected the same is true !
    /*
    mouseMoveCallback(evt) {
    }
    handleSelectedCallback(evt, toolData, handle, interactionType = 'mouse') {
        // moveHandleNearImagePoint(evt, this, toolData, handle, interactionType);
    }
    */

    // toolSelectedCallback(evt, annotation, interactionType = 'mouse') {
    //     // moveAnnotation(evt, this, annotation, interactionType);
    // }

    renderToolData(evt) {
        const eventData = evt.detail;
        const config = this.configuration;

        // If we have no toolData for this element, return immediately as there is nothing to do
        const toolData = cornerstoneTools.getToolState(eventData.element, this.name);
        if (!toolData) {
            return;
        }

        // We have tool data for this element - iterate over each one and draw it
        const context = getNewContext(eventData.canvasContext.canvas);

        for (let i = 0; i < toolData.data.length; i++) {
            const data = toolData.data[i];

            if (data.visible === false) {
                continue;
            }

            const color = cornerstoneTools.toolColors.getColorIfActive(data);
            // const color = 'rgb(0, 255, 0)';

            draw(context, context => {
                // setShadow(context, {
                //     shadow: true,
                //     // shadowColor: '#ff0000',
                //     shadowBlur: 5,
                //     shadowOffsetX: 1,
                //     shadowOffsetY: 1,
                // });

                const textCoords = window.cornerstone.pixelToCanvas(
                    eventData.element,
                    data.handles.end
                );
                const options = {
                    centering: {
                        x: true,
                        y: true,
                    },
                };
                data.handles.end.boundingBox = drawTextBox(
                    context,
                    data.text,
                    textCoords.x,
                    textCoords.y - 10,
                    color,
                    options
                );

                // // FIXME: create just illusion of stroke around !
                // setShadow(context, {
                //     shadow: true,
                //     // shadowColor: '#ff0000',
                //     shadowOffsetX: -1,
                //     shadowOffsetY: -1,
                // });
                // data.handles.end.boundingBox = drawTextBox(
                //     context,
                //     data.text,
                //     textCoords.x,
                //     textCoords.y - 10,
                //     color,
                //     options
                // );
                // setShadow(context, {
                //     shadow: true,
                //     // shadowColor: '#ff0000',
                //     shadowOffsetX: -1,
                //     shadowOffsetY: 1,
                // });
                // data.handles.end.boundingBox = drawTextBox(
                //     context,
                //     data.text,
                //     textCoords.x,
                //     textCoords.y - 10,
                //     color,
                //     options
                // );
                // setShadow(context, {
                //     shadow: true,
                //     // shadowColor: '#ff0000',
                //     shadowOffsetX: 1,
                //     shadowOffsetY: -1,
                // });
                // data.handles.end.boundingBox = drawTextBox(
                //     context,
                //     data.text,
                //     textCoords.x,
                //     textCoords.y - 10,
                //     color,
                //     options
                // );









            });
        }
    }
}
